import { combineReducers } from 'redux';

import { reduce as drawerReducer, namespace as drawerNamespace } from './drawer/orders.drawer.reducer';
import { ConnectedActionHandlerMap as editOrderReducer, namespace as editOrderNamespace } from './edit-order/edit.order.reducer';
import { orderFilter, namespace as filteringNamespace } from './filtering/orders.filtering.reducer';
import { ordersGrid, namespace as gridNamespace } from './grid/orders.grid.reducer';
import { ConnectedActionHandlerMap as navReducer, namespace as navNamespace } from './nav/orders.nav.reducer';
import { orderDetails, namespace as orderDetailsNamespace } from './order-details/orders.details.reducer';
import { ConnectedActionHandlerMap as ordersImportReducer, namespace as ordersImportNamespace } from './import/orders.import.reducer';
import { reduce as selectedOrdersReducer, namespace as selectedOrdersNamespace } from './selected-orders/orders.selected-orders.reducer';

import { optimisticUpdater } from '../optimistic.update.reducer';

export const combinedReducer = combineReducers({
  [drawerNamespace]: drawerReducer,
  [editOrderNamespace]: editOrderReducer,
  [filteringNamespace]: orderFilter,
  [gridNamespace]: optimisticUpdater(ordersGrid),
  [navNamespace]: navReducer,
  [orderDetailsNamespace]: orderDetails,
  [ordersImportNamespace]: ordersImportReducer,
  [selectedOrdersNamespace]: optimisticUpdater(selectedOrdersReducer),
});

export { namespace } from './orders.reducer.metadata';
